import { FiLoader } from "react-icons/fi";
import usePincodeLookup from "../../hooks/usePincodeLookup";
import StateCombobox from "../userProfile/StateCombobox";

export default function PincodeAutoFill({
  pincode,
  onPincodeChange,
  city,
  onCityChange,
  state,
  onStateChange,
  cityLabel = "City",
  pincodeId = "pincode",
  cityId = "city",
  stateId = "state",
  pincodeName = "pincode",
  cityName = "city",
  required = true,
}) {
  const status = usePincodeLookup(pincode, (result) => {
    if (!result || result.clear || result.error) {
      onCityChange("");
      onStateChange("");
      return;
    }
    onCityChange(result.district || result.city || "");
    onStateChange(result.state || "");
  });

  const looking = status.type === "loading";
  const locked = looking || status.type === "success";
  const cityValue = looking ? "Loading..." : city;

  return (
    <>
      <div className="form-group">
        <label htmlFor={pincodeId}>Pincode{required ? " *" : ""}</label>
        <input
          id={pincodeId}
          name={pincodeName}
          value={pincode}
          onChange={(e) => onPincodeChange(e.target.value.replace(/\D/g, "").slice(0, 6))}
          placeholder="6-digit pincode"
          inputMode="numeric"
          maxLength={6}
          required={required}
        />
        {status.type !== "idle" && (
          <p className={`pincode-lookup-hint pincode-lookup-hint--${status.type}`}>
            {looking ? <FiLoader className="pincode-spin" aria-hidden /> : null}
            {status.message}
          </p>
        )}
      </div>

      <div className="form-group">
        <label htmlFor={cityId}>
          {cityLabel}
          {required ? " *" : ""}
        </label>
        <input
          id={cityId}
          name={cityName}
          value={cityValue}
          onChange={(e) => onCityChange(e.target.value)}
          placeholder={cityLabel}
          required={required}
          readOnly={locked}
        />
      </div>

      <div className="form-group">
        <label htmlFor={stateId}>State{required ? " *" : ""}</label>
        {locked ? (
          <input
            id={stateId}
            value={looking ? "Loading..." : state}
            readOnly
            required={required}
          />
        ) : (
          <StateCombobox
            id={stateId}
            value={state}
            required={required}
            onChange={onStateChange}
          />
        )}
      </div>
    </>
  );
}
